module.exports = __webpack_public_path__ + "static/media/delixpress_logo.4f9c8464.svg";